/** Actions from parsed form XML (`<actions>` or legacy `<operations>`). */
export function collectPageActionsFromForm(form: unknown): unknown[] {
  if (form == null || typeof form !== 'object') {
    return []
  }

  const root = form as Record<string, unknown>
  for (const key of ['actions', 'operations']) {
    const container = root[key]
    if (container == null || typeof container !== 'object') {
      continue
    }
    const raw = (container as { action?: unknown }).action
    if (raw == null) {
      continue
    }
    return Array.isArray(raw) ? raw : [raw]
  }

  return []
}
